import { render, staticRenderFns } from "./ChatFeedbackComments.vue?vue&type=template&id=6f0136fa&"
import script from "./ChatFeedbackComments.vue?vue&type=script&lang=ts&"
export * from "./ChatFeedbackComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports